import { atom } from "jotai";

import { SimpleResult } from "../simple-result/simple-result";

import { IZReport, IZReportsCacheKey } from "../models";

/** The current register's Z-reports over the register page's filter range. */
export const zReportsAtom = atom<IZReport[]>([]);

/** What `zReportsAtom` currently holds, so a remount can skip re-fetching it. */
export const zReportsCacheKeyAtom = atom<IZReportsCacheKey | null>(null);

/** Own loading/error pair — see `receiptsLoadingAtom` for why. */
export const zReportsLoadingAtom = atom<boolean>(false);
export const zReportsErrorAtom = atom<SimpleResult<unknown> | null>(null);
